import { useTranslation } from 'react-i18next';

import { useAuth } from '@/contexts/AuthContext';
import { priceFormatterV2 } from '@/lib/utils';
import { Audience } from '@/services/AudiencesService';

interface LTVProps {
  audience: Pick<Audience, 'lifetime_value'>;
}

export function LTV({ audience }: LTVProps) {
  const { user } = useAuth();

  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Behaviors.customBehavior',
  });

  return (
    <div>
      <div className="flex flex-row justify-between gap-2">
        <p className="text-sm text-gray-600">{t('ltvLabel')}</p>
        <div className="text-w-10 flex flex-row items-center gap-2 font-semibold">
          {priceFormatterV2(
            Number(audience.lifetime_value),
            user!.customer.language,
            user!.customer.platform,
          )}
        </div>
      </div>
    </div>
  );
}
